import { render, staticRenderFns } from "./observer.vue?vue&type=template&id=642c941a&"
import script from "./observer.vue?vue&type=script&lang=js&"
export * from "./observer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports